export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "下载信息",
        name: "1",
        icon: "",
        tipsList: [
          { text: "（1）可上传文件类型为图片、文档大小为5MB，大于5MB的文档请分割后上传。" },
          { text: "（2）上传的图片，不能大于5MB,大于5MB的请务必先用图片压缩软件压缩后再进行上传。可加快上传速度。" },
          { text: "（3）软件使用说明：本软件使用简便。可选择目录，对该目录下的图片进行批量压缩。也可直接选择图片进行压缩。" },
          { type: "slot", slotName: "tips" },
        ],
        formConfigList: [
          {
            label: "文件类型：",
            type: "select",
            value: "fileType",
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "请选择文件类型",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510281920370002"
            },
          },
          {
            label: "文件名：",
            type: "input",
            value: "fileName",
            maxlength: 30,
            rule: {
              required: true,
              message: "请填写文件名",
              trigger: "blur"
            }
          },
          {
            label: "文件上传：",
            type: "slot",
            slotName: "uploadFile",
            rule: {
              required: true,
              message: "请上传文件",
              trigger: "blur"
            }
          },
          {
            type: "slot",
            slotName: "tips",
          },
        ]
      },
    ];
  }
}
